import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getAdmissionDetails } from "../../connections/getAdmissionDetails";
import dayjs from "dayjs";
import { Skeleton } from "@mui/material";
import { imagesend } from "../imagepath";
import { deleteAdmission } from "../../connections/deleteAdmission";
import { toast } from "react-toastify";
import { formatDateTime } from "../../utils/constant/constant";
// import { Table } from "antd";

const AdmissionDetails = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const [deleteId, setDeleteId] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: getAdmissionDetailsData, isLoading } = useQuery({
    queryKey: ["getAdmissionDetails", id],
    queryFn: () => getAdmissionDetails(user?.token, id),
    enabled: !!id,
    // staleTime: Infinity, // Keep the data fresh indefinitely

    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });
  // const columns = [
  //   {
  //     title: "Id",
  //     dataIndex: "id",
  //     key: "id",
  //   },
  //   {
  //     title: "Room No",
  //     dataIndex: "room_no",
  //     key: "room_no",
  //   },
  //   {
  //     title: "Check-In",
  //     dataIndex: "checkin",
  //     key: "checkin",
  //     render: (text) =>
  //       dayjs(text, "YYYY-MM-DD HH:mm:ss A").format("MMMM DD, YYYY HH:mm"),
  //   },
  //   {
  //     title: "Check-Out",
  //     dataIndex: "checkout",
  //     key: "checkout",
  //     render: (text) =>
  //       dayjs(text, "YYYY-MM-DD HH:mm:ss A").format("MMMM DD, YYYY HH:mm"),
  //   },
  //   {
  //     title: "Ward No",
  //     dataIndex: "ward_no",
  //     key: "ward_no",
  //   },
  //   {
  //     title: "Bed No",
  //     dataIndex: "bed_no",
  //     key: "bed_no",
  //   },
  //   {
  //     title: "Created At",
  //     dataIndex: "created_at",
  //     key: "created_at",
  //     render: (text) =>
  //       dayjs(text, "YYYY-MM-DD HH:mm:ss A").format("MMMM DD, YYYY HH:mm"),
  //   },
  //   {
  //     title: "Updated At",
  //     dataIndex: "updated_at",
  //     key: "updated_at",
  //     render: (text) =>
  //       dayjs(text, "YYYY-MM-DD HH:mm:ss A").format("MMMM DD, YYYY HH:mm"),
  //   },
  //   {
  //     title: "Patient Name",
  //     dataIndex: "patient_name",
  //     key: "patient_name",
  //     render: (text, record) => record.patient?.full_name,
  //   },
  // ];

  // const data = [
  //   {
  //     key: "1",
  //     room_no: getAdmissionDetailsData?.room_no,
  //     checkin: getAdmissionDetailsData?.checkin,
  //     checkout: getAdmissionDetailsData?.checkout,
  //     ward_no: getAdmissionDetailsData?.ward_no,
  //     bed_no: getAdmissionDetailsData?.bed_no,
  //     created_at: getAdmissionDetailsData?.created_at,
  //     updated_at: getAdmissionDetailsData?.updated_at,
  //     patient_name: getAdmissionDetailsData?.patient?.full_name,
  //   },
  // ];
  const formatDate = (date) =>
    formatDateTime(date);
  const deleteAdmissionFun = async () => {
    try {
      const data = await deleteAdmission(user?.token, deleteId);
      if (data?.status?.status === "SUCCESS") {
        toast.success("Admission Deleted Successfully", deleteId);
        navigate("/admin/admission");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <>
      <Header />
      <Sidebar activeClassName="admission-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item active">
                      <Link to={-1}>Admission Details</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">{id}</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    {/* content Header */}
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                          className="doctor-table-blk"
                        >
                          <h3>Admission Details</h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                            className="doctor-search-blk"
                          >
                            <button
                              className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                              style={{
                                minWidth: "100px",
                                padding: "6px 12px",
                                borderRadius: "6px",
                              }}
                              onClick={() => {
                                navigate("/admin/update_admission", {
                                  state: getAdmissionDetailsData,
                                });
                              }}
                            >
                              <i className="far fa-edit me-2" />
                              Edit
                            </button>

                            <button
                              className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                              style={{
                                minWidth: "100px",
                                padding: "6px 12px",
                                borderRadius: "6px",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target="#delete_patient"
                              onClick={() => {
                                setDeleteId(getAdmissionDetailsData?.id);
                              }}
                            >
                              <i className="fa fa-trash-alt me-2" />
                              Delete
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <div>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={430} // Same height as your chart
                        />
                      </div>
                    ) : (
                      <div className="content-details">
                        <div className="col-lg-12">
                          <div className="card-box">
                            <div className="">
                              <ul style={{textAlign:"start"}} className="personal-info">
                                <li className="pb-1">
                                  <span className="title">Id:</span>
                                  <span className="text">
                                    {getAdmissionDetailsData?.id}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Room No:</span>
                                  <span className="text">
                                    {getAdmissionDetailsData?.room_no}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Check-In:</span>
                                  <span className="text">
                                    {formatDate(
                                      getAdmissionDetailsData?.checkin
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Check-Out:</span>
                                  <span className="text">
                                    {formatDate(
                                      getAdmissionDetailsData?.checkout
                                    )}
                                  </span>
                                </li>
                                 <li  className="pb-1">
                                  <span className="title">Bed No:</span>
                                  <span className="text">
                                    {getAdmissionDetailsData?.bed_no}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Ward No:</span>
                                  <span className="text">
                                    {getAdmissionDetailsData?.ward_no || "NA"}
                                  </span>
                                </li>
                               
                                <li style={{textAlign:"start",}} className="pb-1">
                                  <span className="title">Created At:</span>
                                  <span className="text">
                                    {formatDate(
                                      getAdmissionDetailsData?.created_at
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Updated At:</span>
                                  <span className="text">
                                    {formatDate(
                                      getAdmissionDetailsData?.updated_at
                                    )}
                                  </span>
                                </li>
                                <li className="pb-1">
                                  <span className="title">Patient Name:</span>
                                  <span className="text">
                                    {
                                      getAdmissionDetailsData?.patient
                                        ?.full_name
                                    }
                                  </span>
                                </li>
                              </ul>
                              {/* <div className="table-responsive">
                                <Table
                                  columns={columns}
                                  dataSource={data}
                                  pagination={false}
                                  scroll={{ x: "max-content" }}
                                />
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="delete_patient"
          className="modal fade delete-modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src={imagesend} alt="#" width={50} height={46} />
                <h3>Are you sure want to delete this ?</h3>
                <div className="m-t-20">
                  {" "}
                  <Link
                    to="#"
                    className="btn btn-white me-2"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </Link>
                  <button
                    onClick={deleteAdmissionFun}
                    type="submit"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            id="delete_patient"
            className="modal fade delete-modal"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <img src={imagesend} alt="#" width={50} height={46} />
                  <h3>Are you sure want to delete this ?</h3>
                  <div className="m-t-20">
                    {" "}
                    <Link
                      to="#"
                      className="btn btn-white me-2"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </Link>
                    <button
                      data-bs-dismiss="modal"
                      type="submit"
                      className="btn btn-danger"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default AdmissionDetails;
